import { Action } from '../../definitions/types';
import * as Actions from './actions-consts';

export function setUserIdToken(userIdToken: string): Action<string> {
  return {
    type: Actions.SET_USER_ID_TOKEN,
    payload: userIdToken,
  };
}
